import Vue from 'vue';
import Vuex from 'vuex';

import planning from './planning';

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        planning,
    },
});
